{
  "pt": {
    "dashboard": {
      "greetings": {
        "afternoon": "Boa tarde {first_name}",
        "evening": "Boa noite {first_name}",
        "morning": "Bom dia {first_name}",
        "night": "Boa noite {first_name}"
      },
      "titles": {
        "activityFeed": "Feed de actividades",
        "assignedTasks": "As minhas tarefas",
        "newsFeed": "Feed de notícias",
        "ongoingTickets": "Em curso",
        "openTickets": "Aberto",
        "tickets": "Conversas",
        "totalTickets": "Todas as conversas",
        "unreadTickets": "Não lido",
        "yourAssignedTickets": "Atribuídas a si"
      }
    }
  }
}
